import { render, staticRenderFns } from "./AdmDashboardView.vue?vue&type=template&id=29cbb7b9&scoped=true"
import script from "./AdmDashboardView.vue?vue&type=script&lang=js"
export * from "./AdmDashboardView.vue?vue&type=script&lang=js"
import style0 from "./AdmDashboardView.vue?vue&type=style&index=0&id=29cbb7b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbb7b9",
  null
  
)

export default component.exports